export default __webpack_public_path__ + "static/3-24c38498319bed5d19ab92800cd04304.png";